// ============================================================================
// Onboarding process — the steps, and what's been done (onboarding-checklist)
// ============================================================================
// The wording lives HERE, not in the database. The table stores step_1…step_5
// and a stamp of who ticked it; re-phrasing a step is then a code change that
// leaves every existing tick intact. Reordering or renaming is safe. REMOVING
// a key is not — a tick against it would be orphaned — so retire a step by
// dropping it from this list and leaving the key unused.
//
// Steps are Rob's, verbatim from the brief.
// ============================================================================

export const ONBOARDING_STEPS = [
  {
    key: 'step_1',
    title: 'Set-up Teams meeting',
    detail: 'Introduction between both companies.',
  },
  {
    key: 'step_2',
    title: 'Relevant contractor documents sent',
    detail: 'Which documents depends on their risk tier.',
  },
  {
    key: 'step_3',
    title: 'Supplier has completed and returned documents',
    detail: 'Their side of the paperwork is back with us.',
  },
  {
    key: 'step_4',
    title: 'Contractor escalation information recorded',
    detail: 'Who to contact when something goes wrong on site.',
  },
  {
    key: 'step_5',
    title: 'Face-to-face meeting arranged',
    detail: 'Visit their premises if relevant — payment terms, commission.',
  },
];

// Rows in → a map of what's done. Anything with a key we no longer recognise is
// ignored rather than shown as a mystery tick.
export function completionByStep(rows) {
  const map = {};
  for (const row of rows || []) {
    if (!row?.step_key) continue;
    map[row.step_key] = row;
  }
  return map;
}

// "3 of 5 done" — and, more usefully, whether it's finished at all.
export function checklistProgress(rows) {
  const done = ONBOARDING_STEPS.filter(s => completionByStep(rows)[s.key]).length;
  return {
    done,
    total: ONBOARDING_STEPS.length,
    complete: done === ONBOARDING_STEPS.length,
    // Nothing started is worth distinguishing from part-way: it's the
    // difference between "nobody has picked this up" and "it's in progress".
    started: done > 0,
  };
}
